<template>
  <generic-modal
    :title="$t('transference request')"
    ref="generic_modal"
    @close-modal="set_initial_state"
    size="fullscreen"
  >
    <form>
      <div class="columns">
        <div class="column">
          <!-- Destinatario -->
          <div class="field">
            <generic-dropdown
              :title="$t('destinatary')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/account-request/destinatary/catalog"
              name_field="name"
              value_field="destinatary_id"
              @selected="destinatary_changed"
              ref="destinatary_dropdown"
            />
          </div>
          <pre>{{ selected_destinatary }}</pre>
        </div>
        <div class="column">
          <!-- Entidad -->
          <div class="field">
            <generic-dropdown
              :title="$t('entity')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/account-request/entity/catalog"
              name_field="name"
              value_field="entity_id"
              @selected="entity_changed"
              ref="entity_dropdown"
            />
          </div>
          <pre>{{ selected_entity }}</pre>
        </div>
      </div>
    </form>

    <!-- Mensajes de error -->
    <div class="notification is-danger" v-if="error" v-html="error"></div>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { post, put, get, success_message, error_message } from "@/utils";

export default {
  name: "TransferenceRequestModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {
        destinatary_id: null,
        entity_id: null,
        settings: {},
      },
      error: "",
      selected_destinatary: null,
      selected_entity: null,
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.destinatary_id || !this.meta.entity_id;
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.meta.uuid = uuid;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_entity(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {
        destinatary_id: null,
        entity_id: null,
        settings: {},
      };
      this.error = "";
      this.selected_destinatary = null;
      this.selected_entity = null;
      this.$refs.destinatary_dropdown.clear();
      this.$refs.entity_dropdown.clear();
    },
    get_entity(uuid) {
      let v = this;
      get("/account-request/transference", { uuid: uuid })
        .then((response) => {
          v.meta = response;

          if (response.destinatary_id) {
            v.$refs.destinatary_dropdown.set_value(response.destinatary_id);
          }
          if (response.entity_id) {
            v.$refs.entity_dropdown.set_value(response.entity_id);
          }
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    save() {
      let v = this;
      if (v.is_form_invalid) {
        v.error = "Por favor complete los campos requeridos";
        return;
      }

      v.error = "";
      let data = { ...v.meta };

      if (v.meta.uuid) {
        post("/account-request/transference", data)
          .then(() => {
            success_message(v.$t("transference request updated successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      } else {
        put("/account-request/transference", data)
          .then(() => {
            success_message(v.$t("transference request created successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      }
    },
    destinatary_changed(type) {
      if (type) {
        this.selected_destinatary = type;
        this.meta.destinatary_id = type.destinatary_id;
      }
    },
    entity_changed(type) {
      if (type) {
        this.selected_entity = type;
        this.meta.entity_id = type.entity_id;
      }
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 600px;
  max-width: 90vw;
}
</style>
